import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import {graphql} from 'gatsby';

import {Layout} from '../components/index';
import Header from '../components/Header';
import {htmlToReact} from '../utils';
import Footer from '../components/Footer';
import { TwitchEmbed } from 'react-twitch-embed';
import { ThemeContext } from '../context/ThemeProvider';
import { VscColorMode } from 'react-icons/vsc';
import { Helmet } from 'react-helmet';


// this minimal GraphQL query ensures that when 'gatsby develop' is running,
// any changes to content files are reflected in browser
export const query = graphql`
  query($url: String) {
    sitePage(path: {eq: $url}) {
      id
    }
  }
`;

export default function Index(props) {

  const [mode] = useContext(ThemeContext)

  return (
      <Layout {...props}>

        <Helmet
          title="Hey! 👋"
          meta={[
            {
              property: `og:title`,
              content: "This is my space on the internet. You can browse what I am upto currently, my interests, my projects and much more.",
            },
            {
              property: `og:type`,
              content: `website`,
            },
            {
              property: `og:image`,
              content: `https://pbs.twimg.com/profile_banners/1156872848213889024/1603649846/600x200`,
            },
          ]}
        />

        <Header {...props} site={props.pageContext.site} page={props.pageContext} image={_.get(props, 'pageContext.frontmatter.img_path', null)} />
        <div id="content" className="site-content">
          <h3 className="special-title" style={{
            fontWeight: 900,
            textTransform: "uppercase",
            color: mode ? "#fff" : "#000"
          }}>👋 I'm <span style={{
            backgroundColor: "#000",
            color: "#fff",
            paddingRight: 10,
            paddingLeft: 10
          }}>Digvijay</span></h3>
          <br />
          <main id="main" className="site-main inner">
            <article style={{
              backgroundColor: mode ? "#131415" : "#F4F5F7",
              color: mode ? "#fff" : "#000",
              padding: 10
            }} className="post page post-full">
              {_.get(props, 'pageContext.frontmatter.subtitle', null) && (
              <div className="post-subtitle">
                {htmlToReact(_.get(props, 'pageContext.frontmatter.subtitle', null))}
              </div>
              )}
              <div className="post-content">
                {htmlToReact(_.get(props, 'pageContext.html', null))}
              </div>
            </article>
          </main>
          {/* <div>
            <TwitchEmbed
              width="100%"
              channel="digvijaysrathore"
              id="digvijaysrathore"
              theme="dark"
              muted
              onVideoPause={() => console.log(':(')}
            />
          </div> */}
          <br />
          <iframe src="https://open.spotify.com/embed/playlist/6DOH0c6yXNpUcatNNrY9dQ" width="100%" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
          <br />
          <Footer {...props} site={props.pageContext.site} page={props.pageContext} image={_.get(props, 'pageContext.frontmatter.img_path', null)} />
        </div>
      </Layout>
  )
}
